import React, { useState } from "react";
import HeaderList from "../../../components/HeaderList";
import { Button, Modal, Table } from "antd";
import { ReactComponent as Eye } from "../../../assets/icons/eye.svg";
import LiquidateCash from "./LiquidateCash";

const CashNotReceivedUI = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const columns = [
    {
      title: "Ticket",
      dataIndex: "ticket",
      key: "ticket",
      // Permite ordenar por esta columna
      sorter: (a, b) => a.ticket.localeCompare(b.ticket),
    },
    {
      title: "Driver",
      dataIndex: "driver",
      key: "driver",
      sorter: (a, b) => a.driver.localeCompare(b.driver),
    },
    {
      title: "Teléfono",
      dataIndex: "telefono",
      key: "telefono",
    },
    {
      title: "Sucursal",
      dataIndex: "sucursal",
      key: "sucursal",
    },
    {
      title: "Hora que entrega la orden",
      dataIndex: "horaEntrega",
      key: "horaEntrega",
    },
    {
      title: "Efectivo a entregar",
      dataIndex: "efectivoEntregar",
      key: "efectivoEntregar",
      // Ejemplo de cómo manejar valores numéricos o de moneda para ordenar
      sorter: (a, b) =>
        parseFloat(a.efectivoEntregar.replace("$", "")) -
        parseFloat(b.efectivoEntregar.replace("$", "")),
    },
    {
      title: "Detalle",
      dataIndex: "detalle",
      key: "detalle",
      // Renderizado para mostrar el botón de ojo (vista)
      render: () => (
        <Button>
          <Eye color="#FF671D" />
        </Button>
      ),
    },
    {
      title: "Liquidaciones",
      dataIndex: "liquidaciones",
      key: "liquidaciones",
      // Renderizado para mostrar el botón "Liquidar"
      render: () => (
        <Button
          onClick={() => setIsModalVisible(true)}
          style={{ width: 112 }}
          type="primary"
        >
          Liquidar
        </Button>
      ),
    },
  ];

  const dataSource = [
    {
      key: "1",
      ticket: "L-238972",
      driver: "Francisco Enrique Jimenez",
      telefono: "6109-7231",
      sucursal: "BW Paseo",
      horaEntrega: "2:30:19pm",
      efectivoEntregar: "$12.50",
    },
    {
      key: "2",
      ticket: "L-238972",
      driver: "Joaquín Armando Quiñonez",
      telefono: "7809-4544",
      sucursal: "BW Paseo",
      horaEntrega: "2:30:19pm",
      efectivoEntregar: "$22.38",
    },
    {
      key: "3",
      ticket: "L-238972",
      driver: "Ramón Rodríguez Avalos",
      telefono: "8089-2218",
      sucursal: "BW Paseo",
      horaEntrega: "2:30:19pm",
      efectivoEntregar: "$19.15",
    },
  ];

  return (
    <div>
      <HeaderList back={"/monitor"} title={"Efectivo sin recibir (3)"} />
      <Table columns={columns} dataSource={dataSource} />

      <Modal
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <LiquidateCash />
      </Modal>
    </div>
  );
};

export default CashNotReceivedUI;
